import { ofType, ActionsObservable } from 'redux-observable';
import { map, mergeMap, flatMap } from 'rxjs/operators';
import { from } from 'rxjs';

import {
    TransformProviderInfo
} from './transform';

import {
    addAction as addProviderGlobalSearch,
    setSpin,
} from 'one-state-provider-global-search';

import {
    addAction as addErrorAction
} from 'one-state-error/src/actions';

import {
    ErrorObject
} from 'one-state-error/src/errorobject';
import {format} from 'one-util-date';

export const enum Types {
    SEARCH = 'one-state-provider-global-search/search',
    ADD = 'one-state-provider-global-search/add',
}

const pushToSetProviderGlobalSearch = (payload: any) => addProviderGlobalSearch(payload);

/**
 * This Function fetches data from getproviderinfo api
 * @param context contains settings.json etc...
 */
export const fetchProvidersGlobalSearchEpic = (context: any) => (
    (action$: ActionsObservable<any>) => {
        const errorTime = format(new Date(),'LT');
        const errorDate = format(new Date(),'LL');
        const { server,
            log,
            settings:
            {
                epicendpoints: { providersearch, apitoken },
                soucetypelookup
            }
        } = context;
        return action$.pipe(
            ofType(Types.SEARCH),
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contains the patient global search request
                 */
                const dataresponse: any = action.payload;
                log.debug("one-epics", "provider-global-search request", dataresponse);
                const getProviderDetails = (payload: any) => {
                    let headers = new Headers();
                    headers.set('Authorization', 'Basic ' + apitoken?.token);
                    const response = server.get({
                        path:providersearch+"?phone="+(payload.phone?payload.phone:"")
                                           +"&location="+(payload.location?payload.location:"")
                                           +"&deptname="+(payload.dept?payload.dept:"")
                                           +"&name="+(payload.name?payload.name:""),
                        headers: headers
                    }).then((responsefound: any) => responsefound)
                        .catch((responseresult: any) => {
                            log.error("one-epic", "provider-global-search-epic Error", responseresult);
                                let pgserror: ErrorObject = {
                                    source: "Provider Global Search",
                                    type: "error",
                                    status: responseresult?.status,
                                    erroritems: responseresult?.errors,
                                    error_date: errorDate,
                                    error_time: errorTime
                                };
                                return pgserror;
                        })
                    log.debug("one-epics", "provider-global-search-epic response", response);
                    return from(response);
                }
                return getProviderDetails(dataresponse).pipe(
                    map(response => TransformProviderInfo(response, context, soucetypelookup))
                ).pipe(
                    flatMap(response => {
                        const actions: any = [
                            pushToSetProviderGlobalSearch(response.providersourcedata)
                        ];
                        // check for error messages.
                        if (response.error) {
                            actions.push(addErrorAction(response.error));
                        }
                        return actions;
                    })
                )
            })
        )
    }

);

/**
 * This Fuction will stop spinner for 
 * provider global search epic redux action
 * @param context contains the settings,logger etc..
 */
export const resetSpinForProviderGlobalSearchEpic = (context: any) => (
    (action$: any) => {
        const { log} = context;
        log.debug(
            "ccw-gadget,provider-global-search-epic",
            "setSpin-provider-global-search-epic", {
            });
        return action$.pipe(
            ofType(Types.ADD),
            map(action => setSpin(false))
        )
    }
);
